import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";
import { formatMoney, SITE_CONFIG } from "../config/siteConfig";

function TermsOfSale() {
  return (
    <PolicyLayout
      title="Terms of sale"
      intro="These terms apply to the physical products placed in a mavormira cart and submitted through the hosted payment flow."
    >
      <section>
        <h2>Order information and total</h2>
        <p>Before Pay Now, the cart identifies the product, selected option, quantity and merchandise subtotal. Checkout then adds one {formatMoney(SITE_CONFIG.shippingFee)} shipping charge and displays the total in {SITE_CONFIG.currency}. The buyer must check the basket, email, destination and delivery details before continuing.</p>
      </section>

      <section>
        <h2>Payment session and order acceptance</h2>
        <p>Pay Now creates a hosted Stripe checkout session using a unique order number, the displayed total, currency, customer email and first item title. Payment details are entered on that hosted page. A browser success screen records only the return route; acceptance and fulfilment require the associated payment to be verified through the merchant's payment record.</p>
        <p>An order may be declined before acceptance where payment is not authorised, required information is invalid, an item cannot be supplied, alcohol age or destination rules are not met, or the transaction presents evidence of fraud or misuse. If captured funds cannot support an accepted order, they must be returned through the original payment route.</p>
      </section>

      <section>
        <h2>Physical goods and buyer checks</h2>
        <p>Dimensions and materials are stated per product. Buyers of tableware, food, drinks, spirits, electrical lamps, candle accessories and sharp or small accessories must review the relevant product description and the <Link to="/product-safety">Product safety and care policy</Link>. The delivered food, beverage and alcohol label controls ingredients, allergens, storage dates and alcohol strength.</p>
      </section>

      <section>
        <h2>Delivery, cancellation and remedies</h2>
        <p>Available destinations and import responsibility are governed by the <Link to="/shipping">Shipping policy</Link> and <Link to="/international-orders">International orders policy</Link>. A cancellation request is effective only if fulfilment can still be stopped and support confirms it. Delivery problems and product remedies follow their dedicated procedures so that the item, parcel and payment evidence can be assessed safely.</p>
      </section>

      <section>
        <h2>Rights that remain in force</h2>
        <p>Product-specific return limits for opened consumables or used goods do not remove remedies for an item that is unsafe, falsely described, materially different, damaged in transit or incorrectly supplied. These terms do not replace any protection that Hong Kong law or another mandatorily applicable consumer rule does not permit a seller to exclude.</p>
      </section>
    </PolicyLayout>
  );
}

export default TermsOfSale;
